<template>
  <div class="flex flex-col p-3 space-y-2">

    <AppModal v-model="showNewTaxHead" size="lg" title="New Tax Head" hide-footer>
      <div class="space-y-3">
        <div class="grid grid-cols-2 gap-3">
          <input type="text"
                 class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                 v-model="form.taxHeadName" placeholder="Tax Head Name" />
          <input type="text"
                 class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                 v-model="form.taxHeadId" placeholder="Tax Head ID" />
          <input type="text"
                 class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm col-span-2"
                 v-model="form.taxHeadCode" placeholder="Tax Head Code" />
        </div>
        <textarea v-model="form.taxHeadDescription" placeholder="Tax Head Description" rows="3"
                  class="w-full px-3 py-2 text-sm border border-gray-300 rounded resize-vertical focus:outline-none focus:ring-2 focus:ring-primary"></textarea>
        <div class="grid grid-cols-2 gap-3">
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Base Value</label>
            <input type="number"
                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                   v-model="form.baseValue" placeholder="Base Value" />
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Percentage %</label>
            <input type="text"
                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                   v-model="form.percentage" placeholder="Percentage" />
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Fees Per Unit</label>
            <input type="text"
                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                   v-model="form.feesPerUnit" placeholder="Fees Per Unit" />
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Is Active</label>
            <select v-model="form.isActive"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
              <option v-for="opt in yesNo" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Available On</label>
            <select v-model="form.isAvailableOnPortal"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
              <option v-for="opt in yesOnPortalNo" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Description Displayed</label>
            <select v-model="form.isDescriptionDisplayed"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
              <option v-for="opt in yesNo" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">TIN Mandatory</label>
            <select v-model="form.isTinMandatory"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
              <option v-for="opt in yesNo" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Reference Type Mandatory</label>
            <select v-model="form.isReferenceTypeMandatory"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
              <option v-for="opt in yesNo" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
        </div>
        <p class="text-xs font-semibold text-gray-600 mt-2">Tax Head Levels</p>
        <div class="grid grid-cols-2 gap-3">
          <div v-for="(level, key) in levelOptions" :key="key">
            <label class="text-xs text-gray-600 mb-1 block">{{ key.replace("_", " ").toUpperCase() }}</label>
            <select v-model="(form as any)[key]"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
              <option :value="null">-- Select --</option>
              <option v-for="opt in level" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
        </div>
        <div class="flex justify-end pt-2">
          <button class="btn-primary" @click="save">
            <i class="fa fa-save mr-1"></i> Save
          </button>
        </div>
      </div>
    </AppModal>

    <AppModal v-model="showViewTaxHead" size="lg" title="Edit Tax Head" hide-footer>
      <div class="space-y-3" v-if="selectedTaxHead">
        <div class="grid grid-cols-2 gap-3">
          <input type="text"
                 class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                 v-model="selectedTaxHead.taxHeadName" placeholder="Tax Head Name" />
          <input type="text"
                 class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                 v-model="selectedTaxHead.taxHeadId" placeholder="Tax Head ID" />
          <input type="text"
                 class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm col-span-2"
                 v-model="selectedTaxHead.taxHeadCode" placeholder="Tax Head Code" />
        </div>
        <textarea v-model="selectedTaxHead.taxHeadDescription" placeholder="Tax Head Description" rows="3"
                  class="w-full px-3 py-2 text-sm border border-gray-300 rounded resize-vertical focus:outline-none focus:ring-2 focus:ring-primary"></textarea>
        <div class="grid grid-cols-2 gap-3">
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Base Value</label>
            <input type="number"
                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                   v-model="selectedTaxHead.baseValue" />
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Percentage %</label>
            <input type="text"
                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                   v-model="selectedTaxHead.percentage" />
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Fees Per Unit</label>
            <input type="text"
                   class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
                   v-model="selectedTaxHead.feesPerUnit" />
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Is Active</label>
            <select v-model="selectedTaxHead.isActive"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
              <option v-for="opt in yesNo" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Available On</label>
            <select v-model="selectedTaxHead.isAvailableOnPortal"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
              <option v-for="opt in yesOnPortalNo" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Description Displayed</label>
            <select v-model="selectedTaxHead.isDescriptionDisplayed"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
              <option v-for="opt in yesNo" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">TIN Mandatory</label>
            <select v-model="selectedTaxHead.isTinMandatory"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
              <option v-for="opt in yesNo" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
          <div>
            <label class="text-xs text-gray-600 mb-1 block">Reference Type Mandatory</label>
            <select v-model="selectedTaxHead.isReferenceTypeMandatory"
                    class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
              <option v-for="opt in yesNo" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
        </div>
        <div class="flex justify-end pt-2">
          <button class="btn-primary" @click="editTaxHead">
            <i class="fa fa-pen-square mr-1"></i> Save Changes
          </button>
        </div>
      </div>
    </AppModal>

    <!-- Header -->
    <div class="flex justify-end py-3">
      <button class="btn-primary" @click="showNewTaxHead = true">
        <i class="fa fa-plus mr-1"></i> Add Tax Head
      </button>
    </div>

    <!-- Table -->
    <div>
      <table>
        <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Tax Head</th>
          <th>Available On</th>
          <th>Base Value</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <template v-if="loading">
          <tr v-for="i in 5" :key="`sk-${i}`" class="animate-pulse">
            <td>
              <div class="h-3 bg-gray-200 rounded w-6"></div>
            </td>
            <td>
              <div class="h-3 bg-gray-200 rounded w-40"></div>
            </td>
            <td>
              <div class="h-3 bg-gray-200 rounded w-20"></div>
            </td>
            <td>
              <div class="h-3 bg-gray-200 rounded w-28"></div>
            </td>
            <td>
              <div class="h-3 bg-gray-200 rounded w-16"></div>
            </td>
            <td>
              <div class="h-3 bg-gray-200 rounded w-14"></div>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr v-for="(taxhead, idx) in taxheads" :key="idx">
            <td>{{ idx + 1 }}</td>
            <td class="font-bold">{{ taxhead.taxHeadName }}</td>
            <td>{{ taxhead.taxHeadCode }}</td>
            <td>
                <span v-if="taxhead.isAvailableOnPortal === 'YES'"
                      class="inline-flex items-center gap-1 text-xs bg-green-50 text-green-700 px-2 py-0.5 rounded-full">
                  <i class="fa fa-check"></i> OBRS Portal
                </span>
              <span v-else
                    class="inline-flex items-center gap-1 text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">
                  <i class="fa fa-globe"></i> Both Portals
                </span>
            </td>
            <td class="font-medium">UGX {{ taxhead.baseValue?.toLocaleString() }}</td>
            <td>
              <button class="btn-sm-primary" @click="openEdit(taxhead)">
                <i class="fa fa-edit mr-1"></i> Edit
              </button>
            </td>
          </tr>
        </template>
        <tr v-if="!loading && taxheads.length === 0">
          <td colspan="6" class="text-center py-6 text-gray-400 text-sm">No results found</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import AppModal from "@/components/ui/AppModal.vue";
import { useBillingStore } from "@/domains/home/services/billing/stores";

const billingStore = useBillingStore();

const showNewTaxHead = ref(false);
const showViewTaxHead = ref(false);
const loading = ref(false);
const taxheads = ref<any[]>([]);
const selectedTaxHead = ref<any>(null);

const yesNo = [{ value: "YES", text: "Yes" }, { value: "NO", text: "No" }];
const yesOnPortalNo = [{ value: "YES", text: "Only OBRS Portal" }, {
  value: "BOTH",
  text: "Both OBRS and Non OBRS URSB service portals"
}];

const levelOptions: Record<string, { value: string; text: string }[]> = {
  level_1: [{ value: "UGANDA REGISTRATION SERVICES BUREAU", text: "UGANDA REGISTRATION SERVICES BUREAU" }],
  level_2: [
    { value: "ADMINISTRATION", text: "ADMINISTRATION" },
    { value: "BUSINESS NAME REGISTRATION DEPARTMENT", text: "BUSINESS NAME REGISTRATION DEPARTMENT" },
    { value: "CIVIL REGISTRATION DEPARTMENT", text: "CIVIL REGISTRATION DEPARTMENT" },
    { value: "INTELLECTUAL PROPERTY DEPARTMENT", text: "INTELLECTUAL PROPERTY DEPARTMENT" },
    { value: "OFFICIAL RECEIVER/LIQUIDATION DEPARTMENT", text: "OFFICIAL RECEIVER/LIQUIDATION DEPARTMENT" }
  ],
  level_3: [
    { value: "TENDER FEES", text: "TENDER FEES" }, { value: "BUSINESS NAMES", text: "BUSINESS NAMES" },
    { value: "COMPANY REGISTRATION", text: "COMPANY REGISTRATION" }, { value: "FINES/PENALTY", text: "FINES/PENALTY" },
    { value: "REGISTRATION OF CHARGES OF COMPANIES", text: "REGISTRATION OF CHARGES OF COMPANIES" },
    { value: "REGISTRATION OF CHATTELS", text: "REGISTRATION OF CHATTELS" },
    { value: "REGISTRATION OF DOCUMENTS", text: "REGISTRATION OF DOCUMENTS" },
    { value: "CHURCH/HINDU AND ISLAMIC MARRIAGES", text: "CHURCH/HINDU AND ISLAMIC MARRIAGES" },
    { value: "CUSTOMARY MARRIAGES", text: "CUSTOMARY MARRIAGES" },
    { value: "MARRIAGE UNDER MARRIAGE ACT", text: "MARRIAGE UNDER MARRIAGE ACT" },
    { value: "SINGLE STATUS LETTER", text: "SINGLE STATUS LETTER" },
    { value: "LOCAL", text: "LOCAL" }, { value: "FOREIGN", text: "FOREIGN" },
    { value: "CORPORATE INSOLVENCY", text: "CORPORATE INSOLVENCY" },
    { value: "INDIVIDUAL INSOLVENCY", text: "INDIVIDUAL INSOLVENCY" },
    { value: "REGULATION OF INSOLVENCY PRACTICE", text: "REGULATION OF INSOLVENCY PRACTICE" }
  ],
  level_4: [
    { value: "UTILITY MODEL", text: "UTILITY MODEL" }, { value: "TRADEMARKS", text: "TRADEMARKS" },
    { value: "TECHNOVATIONS", text: "TECHNOVATIONS" }, { value: "PATENTS", text: "PATENTS" },
    { value: "INDUSTRIAL DESIGN", text: "INDUSTRIAL DESIGN" },
    { value: "GEOGRAPHICAL INDICATIONS", text: "GEOGRAPHICAL INDICATIONS" },
    { value: "COPYRIGHT", text: "COPYRIGHT" }
  ],
  level_5: [
    { value: "CERTIFICATION MARKS", text: "CERTIFICATION MARKS" },
    { value: "DEFENSIVE MARK", text: "DEFENSIVE MARK" },
    { value: "TRADEMARKS", text: "TRADEMARKS" }
  ],
  level_6: []
};

const form = ref<any>({
  taxHeadCode: null, taxHeadId: null, taxHeadName: null, taxHeadDescription: null,
  isActive: "YES", isAvailableOnPortal: "YES", isDescriptionDisplayed: "YES",
  isTinMandatory: "YES", isReferenceTypeMandatory: "YES",
  baseValue: 0, baseValueCurrency: "UGANDA_SHILLINGS", taxHeadCurrency: "UGANDA_SHILLINGS",
  percentage: 0, feesPerUnit: 0,
  level_1: null, level_2: null, level_3: null, level_4: null, level_5: null, level_6: ""
});

onMounted(() => {
  loading.value = true;
  billingStore.fetchTaxHeads();
});

const save = () => {
  billingStore.createTaxHead(form.value);
};

const openEdit = (taxhead: any) => {
  selectedTaxHead.value = { ...taxhead };
  showViewTaxHead.value = true;
};

const editTaxHead = () => {
  billingStore.updateTaxHead(selectedTaxHead.value);
};

watch(() => billingStore.taxHeads, (data) => {
  loading.value = false;
  if (Array.isArray(data)) taxheads.value = data;
  else if (data?.data) taxheads.value = data.data;
});

watch(() => billingStore.taxHead, (data) => {
  if (data) {
    showNewTaxHead.value = false;
    showViewTaxHead.value = false;
    loading.value = true;
    billingStore.fetchTaxHeads();
  }
});
</script>
